import { render, staticRenderFns } from "./forbidden.vue?vue&type=template&id=a8328f30"
import script from "./forbidden.vue?vue&type=script&lang=js"
export * from "./forbidden.vue?vue&type=script&lang=js"
import style0 from "./forbidden.vue?vue&type=style&index=0&id=a8328f30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports